import React from 'react';
import { Box, Stack } from '@mui/material';
import { EventRepeat } from '@mui/icons-material';
import { SectionHeaderWithCommand, SectionPaper } from '../../../../common/components';
import { useAppSelector } from '../../../../../app/hooks';
import {
  RecurrenceTypeEdit,
  IntervalEdit,
  WeekDaysEdit,
  DayOfMonthEdit
} from '../fields';

/**
 * ScheduleConfigurationSection - Contains schedule configuration
 */
export const ScheduleConfigurationSection: React.FC = () => {
  const { currentRecurringTask } = useAppSelector(state => state.recurringTask);
  const scheduleType = currentRecurringTask?.schedule?.type || 'DAILY';

  return (
    <Box>
      <SectionHeaderWithCommand
        icon={<EventRepeat sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
        title="Schedule Configuration"
      />
      
      <SectionPaper>
        <Stack spacing={2}>
          <Stack direction="row" gap={2}>
            <RecurrenceTypeEdit />
            <IntervalEdit />
          </Stack>
          
          {scheduleType === 'WEEKLY' && <WeekDaysEdit />}
          {scheduleType === 'MONTHLY' && <DayOfMonthEdit />}
        </Stack>
      </SectionPaper>
    </Box>
  );
};

export default ScheduleConfigurationSection;
